import { formatJsonLocation as fjl } from "../../components/renderers";
import { formatJsonDataset as fjd } from "../../components/renderers";

export const attendanceconfig = {
    attendance: {
        service: {
            name: 'attendance',
            title: 'Attendance',
            key: 'rid',
            num: true,
            pageMode: 'remote',
            fields: ['pid', 'rid', 'mno', 'sno', 'mti', 'mtc', 'mpi', 'mpc', 'mph', 'msi', 'msc', 'bat', 'ssi', 'ssc', 'sts', 'ast', 'stp'],
            params: { mno: 'MeterNo', sno: 'StsNo', mti: 'Type', mpi: 'Phase', msi: 'StatusId', bat: 'Batch', ssi: 'StateId', sts: 'Status' },
            grid: [['cit', 'Checkin Time'], ['cot', 'Checkout'], ['mfn', 'First Name'], ['mln', 'Last Name'],['sna', 'Mass'],['cmn', 'Checkin Method'],
            ['qrp', 'Purpose']],
            bar: { pag: true, btn: ['view'] },
            menu: { mnu: [{ t: 'Meter', v: 'mno' }, { t: 'STS', v: 'sno' }], def: 'mno' },
            eform: [
                { id: 'cit', label: 'Checkin time', type: 'df' },
                { id: 'mfn', label: 'First Name', type: 'tf', },
                { id: 'mln', label: 'Other Name', type: 'tf',  },
                { id: 'sna', label: 'Mass', type: 'tf' },
                { id: 'cmn', label: 'Checkin Method', type:'tf' },
                { id: 'qrp', label: 'QR Code Purpose', type: 'tf'},
            ],
        },
        create: false,
        actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete', view: 'View' },
        panels: { add: 'wizard', edit: 'column', delete: 'dialog', view: 'simple' },
        formatters: { grid: { geo: fjl, exi: fjd } }
    },
    service: {
        service: {
            name: 'service',
            title: 'Mass',
            key: 'rid',
            num: true,
            pageMode: 'remote',
            fields: ['', 'rid', 'mno', 'sno', 'mti', 'mtc', 'mpi', 'mpc', 'mph', 'msi', 'msc', 'bat', 'ssi', 'ssc', 'sts', 'ast', 'stp'],
            params: { mno: 'MeterNo', sno: 'StsNo', mti: 'Type', mpi: 'Phase', msi: 'StatusId', bat: 'Batch', ssi: 'StateId', sts: 'Status' },
            grid: [['nam', 'Name'], ['shc', 'Code'], ['dsc', 'Description'], ['sta', 'Start Time'],['ena', 'Closing Time'],['lcn', 'Location'],
            ['mcd', 'Ministry'],['iac', 'Active']],
            bar: { pag: true, btn: ['view'] },
            menu: { mnu: [{ t: 'Meter', v: 'mno' }, { t: 'STS', v: 'sno' }], def: 'mno' },
            eform: [
                { id: 'nam', label: 'Name', type: 'tf',req:1 },
                { id: 'dsc', label: 'Description', type: 'tf',req:0  },
                { id: 'sta', label: 'Start Time', type: 'dt',req:1 },
                { id: 'ena', label: 'Closing Time', type:'dt',req:1 },
                { id: 'mnc', label: 'Ministry', type: 'fa',req:1,cp: { t: 'lcs', s: 'ministry' }},
                { id: 'lci', label: 'Auditorium', type: 'fa',req:1,cp: { t: 'bcs', s: 'auditoriumlocation' }},
                { id: 'sti', label: 'Record Status', type: 'fa',req: 0, ops: {}, cp: { t: 'lcs', s: 'status' }},
            ],
        },
        create: true,
        actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete', view: 'View' },
        panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' },
        formatters: { grid: { geo: fjl, exi: fjd } }
    },
}